import { render } from "./OptionsLabel.vue?vue&type=template&id=33019f3f"
import script from "./OptionsLabel.vue?vue&type=script&lang=js"
export * from "./OptionsLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__